import React, { useState } from 'react';
import { MdArrowDropDown } from "react-icons/md";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import { useEffect } from 'react';
import Sidebar from '../Components/Sidebar';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function EditCoupon() {
    const navigate = useNavigate();
    const { cupon_id } = useParams();
    const cuponId = cupon_id;
    const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
    const [cuponevent, setCuponevent] = useState("");
    const [cuponcode, setCuponcode] = useState("");
    const [cupondiscount, setCupondiscount] = useState("");
    const [validdays, setValiddays] = useState("");
    const [cuponassign, setCuponassign] = useState([]);
    const [cupon, setCupon] = useState([]);
    const [iscuponcodeValid, setIsCuponcodeValid] = useState(true);
    const [isDiscountValid, setIsDiscountValid] = useState(true);
    const [isValiddaysValid, setIsValiddaysValid] = useState(true);
    const [totalCount1, setTotalCount1] = useState(null);
    const [SelectedCupon, setSelectedCupon] = useState({});
    const [user, setUser] = useState([]);
    const [yourDataArray, setYourDataArray] = useState([
        { id: 1, email: 'Super Admin' },
        { id: 2, email: 'Admin' },
        { id: 3, email: 'Affiliate' },
        { id: 4, email: 'User' },
    ]);


    // toggle dropdown
    const toggleDropdownfilter = () => {
        setIsDropdownOpenfilter(!isDropdownOpenfilter);
    };

    // Checkbox state 

    const [checkboxStates, setCheckboxStates] = useState(user.map(() => false));
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    // Function to handle checkbox change for a specific item
    const handleCheckboxChanged = (index) => {
        const newCheckboxStates = [...checkboxStates];
        newCheckboxStates[index] = !newCheckboxStates[index];
        setCheckboxStates(newCheckboxStates);

        const selectedAccess = user
            .filter((_, i) => newCheckboxStates[i])
            .map(item => item.email);
        setCuponassign(selectedAccess);
    };

    // Function to handle "Select All" checkbox change
    const handleSelectAllChanged = () => {
        setSelectAllChecked(!selectAllChecked);
        setCheckboxStates(Array(user.length).fill(!selectAllChecked));

        // Update the access state based on selected checkboxes
        const selectedAccess = user
            .map((item, i) => (!selectAllChecked || checkboxStates[i]) ? item.email : null)
            .filter(Boolean);
        setCuponassign(selectedAccess);
    };

    const countCheckedUsers = () => {
        const checkedCount = checkboxStates.filter((isChecked) => isChecked).length;
        return checkedCount;
    };
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await fetch(`${Constant.BASE_URL}/user/get`);
                const data = await response.json();

                if (data && data.admins) {
                    setUser(data.admins);
                    setCheckboxStates(data.user.map(() => false));
                    if (data.success) {
                        setTotalCount1(data.totalCount);
                    }
                }

            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        fetchUser();
    }, []);
    // update 
    useEffect(() => {
        if (cupon.length > 0) {
            getCuponById(cupon_id)
        }
    }, [cupon])

    useEffect(() => {

        setValue()
    }, [SelectedCupon])

    const setValue = () => {
        setCuponevent(SelectedCupon.cuponevent)
        setCuponcode(SelectedCupon.cuponcode)
        setCupondiscount(SelectedCupon.cupondiscount)
        setValiddays(SelectedCupon.validdays)
        setCuponassign(SelectedCupon.cuponassign)
    }

    const getCuponById = (id) => {
        setSelectedCupon(
            cupon.find((item) => {
                return item._id == id
            })
        )
    }

    useEffect(() => {
        const fetchCoupon = async () => {
            try {
                const response = await fetch(`${Constant.BASE_URL}/cupon/get`);
                const data = await response.json();
                // setUser(data.admins);
                if (data && data.cupon) {
                    setCupon(data.cupon);
                    if (data.success) {
                        setTotalCount1(data.totalCount);
                    }
                }

            } catch (error) {
                console.error("Error fetching affiliate:", error);
            }
        };
        fetchCoupon();
    }, []);

    // validations for cupon
    const validateCuponcode = (cupondiscount) => {
        const cuponcodeRegex = /^[a-zA-Z0-9]+$/;
        return cuponcodeRegex.test(cuponcode);
    };
    const validateCupondiscount = (cupondiscount) => {
        const cupondiscountRegex = /^[0-9]+$/;
        return cupondiscountRegex.test(cupondiscount);
    };
    const validateValiddays = (validdays) => {
        const validdaysRegex = /^[0-9]+$/;
        return validdaysRegex.test(validdays);
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        const iscuponcodeValid = validateCuponcode(cupondiscount);
        const isDiscountValid = validateCupondiscount(cupondiscount);
        const isValiddaysValid = validateValiddays(validdays);
        setIsCuponcodeValid(iscuponcodeValid);
        setIsDiscountValid(isDiscountValid);
        setIsValiddaysValid(isValiddaysValid);
        if (iscuponcodeValid && isDiscountValid && isValiddaysValid) {
            try {
                const cuponData = {
                    cuponevent,
                    cuponcode,
                    cupondiscount,
                    validdays,
                    cuponassign,
                };
                const response = await axios.put(
                    `${Constant.BASE_URL}/cupon/update`,
                    cuponData
                );
                console.log(response.data);

                if (response.status === 201) {

                    setCuponevent("");
                    setCuponcode("");
                    setCupondiscount("");
                    setValiddays("");
                    setCuponassign([]);

                    // Success message
                    toast.success("Coupon updaed successfully");

                    setTimeout(() => {
                        // handleClose();
                        // Navigate to /viewclients
                        navigate("/subscriotionCuppon501");
                    }, 3000);
                } else {
                    console.log("Update failed:", response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };


    return (

        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className=''>
                {cupon.map((cupon) => (
                    <div key={cupon._id}>
                        <div className="popup-form">
                            <div className="w-full  flex items-center justify-center">
                                <div className="bg-white p-4 rounded-md shadow-md  py-3 px-1 lg:py-3 xl:py-3 2xl:p-4  ">
                                    <div className="lg:w-[280px] xl:w-[320px] 2xl:w-[380px] items-center justify-center">
                                        <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl ">
                                            Edit Coupon
                                        </div>
                                        <hr className="mt-1 " />

                                        <form onSubmit={handleUpdate}>
                                            <div className="flex flex-col justify-center items-center ">
                                                <div className="lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                                    <div className="flex py-3 justify-end items-center">
                                                        <label
                                                            htmlFor="yourInput"
                                                            className="flex items-end px-3"
                                                        >
                                                            Coupon Event :
                                                            <span className="text-red-500 ml-1">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="yourInput"
                                                            className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                            style={{ width: "163px", textAlign: "center" }}
                                                            placeholder="Text"
                                                            value={cuponevent}
                                                            onChange={(e) => setCuponevent(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="flex py-3 justify-end items-center">
                                                        <label
                                                            htmlFor="yourInput"
                                                            className="flex items-end px-3"
                                                        >
                                                            Coupon Code :
                                                            <span className="text-red-500 ml-1">*</span>
                                                        </label>
                                                        <div className="flex flex-col">
                                                            <input
                                                                type="text"
                                                                id="couponCode"
                                                                name="couponCode"
                                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                style={{ width: "163px", textAlign: "center" }}
                                                                placeholder="Alpha Numeric"
                                                                value={cuponcode}
                                                                onChange={(e) => setCuponcode(e.target.value)}
                                                                required
                                                            />
                                                            {!iscuponcodeValid && (
                                                                <p className="text-red-500">
                                                                    Invalid cuponcode. Should be alpha-numeric.
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex py-3 justify-end items-center">
                                                        <label
                                                            htmlFor="yourInput"
                                                            className="flex items-end px-3"
                                                        >
                                                            Coupon Discount :
                                                            <span className="text-red-500 ml-1">*</span>
                                                        </label>
                                                        <div className="flex flex-col">
                                                            <input
                                                                type="text"
                                                                id="couponDiscount"
                                                                name="couponDiscount"
                                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                style={{ width: "163px", textAlign: "center" }}
                                                                placeholder="Number %"
                                                                value={cupondiscount}
                                                                onChange={(e) => setCupondiscount(e.target.value)}
                                                                required
                                                            />
                                                            {!isDiscountValid && (
                                                                <p className="text-red-500">
                                                                    Invalid cupondiscount. Should be a number.
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex py-3 justify-end items-center">
                                                        <label
                                                            htmlFor="yourInput"
                                                            className="flex items-end px-3"
                                                        >
                                                            Valid Days :<span className="text-red-500 ml-1">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="yourInput"
                                                            className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                            style={{ width: "163px", textAlign: "center" }}
                                                            placeholder="Text (10 Days)"
                                                            value={validdays}
                                                            onChange={(e) => setValiddays(e.target.value)}
                                                            required
                                                        />
                                                        {!isValiddaysValid && (
                                                            <p className="text-red-500">
                                                                Invalid validdays. Should be a number.
                                                            </p>
                                                        )}
                                                    </div>

                                                    <div className="flex justify-end">
                                                        <div className="flex py-1 justify-end items-center mb-10">
                                                            <label
                                                                htmlFor="yourInput"
                                                                className="flex items-end px-3"
                                                            >
                                                                <p className="text-black">Coupon Assign :{countCheckedUsers()} selected/{totalCount1}</p>
                                                            </label>
                                                            <div className="relative" >
                                                                <div >
                                                                    <div onClick={toggleDropdownfilter} className="focus:outline-none border-b border-black cursor-pointer ">
                                                                        <div className="w-[140px] flex  items-center justify-end relative px-5 lg:px-2">
                                                                            <p className='text-4lg 2xl:text-4xl lg:text-[10px] xl:text-[15px]  bg-white shadow-md border border-white '> </p> <MdArrowDropDown className=" shadow-md pt-1 text-2xl" />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                {/* Dropdown Content */}
                                                                {isDropdownOpenfilter && (
                                                                    <div
                                                                        style={{
                                                                            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                                                            borderRadius: '0 0 5px 5px',
                                                                            zIndex: '100',
                                                                            background: 'rgba(0, 0, 0, 0.25)',
                                                                        }}
                                                                        className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-25 bg-white border border-white border-opacity-60 bg-white"
                                                                    >
                                                                        {/* Dropdown Options */}
                                                                        <ul className='overflow-y-auto h-[130px] createmodal'>

                                                                            {/* "Select All" checkbox */}
                                                                            <li className="border-t px-2 py-1  cursor-pointer text-black flex justify-between items-center">
                                                                                <span className='text-[12px]'>All</span>
                                                                                <div className='flex justify-end items-center'>
                                                                                    <label className="inline-flex items-center">
                                                                                        <div className={`w-4 h-4 bg-white  border-red-500 rounded-sm flex items-center justify-center ml-2 ${selectAllChecked ? 'bg-red-500' : ''}`}>
                                                                                            {selectAllChecked && (
                                                                                                <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                                            )}
                                                                                        </div>
                                                                                        <input
                                                                                            className="hidden"
                                                                                            type="checkbox"
                                                                                            checked={selectAllChecked}
                                                                                            onChange={handleSelectAllChanged}
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </li>

                                                                            {yourDataArray.map((item, index) => (
                                                                                <div key={item.id} className="border-t px-2 py-1  cursor-pointer text-black flex justify-between items-center">
                                                                                    <span className='text-[12px]'>{item.email}</span>
                                                                                    <div className='flex items-center'>
                                                                                        <label className="inline-flex items-center">
                                                                                            <div
                                                                                                className={`w-4 h-4 bg-white border-red-500 rounded-sm flex items-center justify-center ml-2 ${checkboxStates[index] ? '' : ''
                                                                                                    }`}
                                                                                            >
                                                                                                {checkboxStates[index] && (
                                                                                                    <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                                                )}
                                                                                            </div>

                                                                                            <input
                                                                                                className="hidden"
                                                                                                type="checkbox"
                                                                                                checked={checkboxStates[index]}
                                                                                                onChange={() => handleCheckboxChanged(index)}
                                                                                            />

                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className="button-container flex justify-center p-1 space-x-12 lg:pb-1 xl:pb-5 2xl:pb-5 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
                                                >
                                                    <Link to="/subscriotionCuppon501">
                                                        <button
                                                            type="button"
                                                            className=" bg-white px-3 py-1 flex-shrink-0 shadow-md"
                                                            style={{
                                                                boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </Link>
                                                    <button
                                                        type="submit"
                                                        className="px-3 py-1 flex-shrink-0 "
                                                        style={{
                                                            background:
                                                                "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                                        }}
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>

    )
}